import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ProtectedComponent = ({ children, allowedRoles }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkAccess = () => {
      try {
        const storedUser = localStorage.getItem("userDetails");
        if (!storedUser) {
          navigate("/auth/login");
          return;
        }

        const parsedUser = JSON.parse(storedUser);
        const userRole = parsedUser?.role;

        if (allowedRoles && !allowedRoles.includes(userRole)) {
          navigate("/legacyAdmin/dashboard");
          return;
        }
      } catch (error) {
        navigate("/auth/login");
      }
    };

    checkAccess();
  }, [navigate, allowedRoles]);

  return children;
};

export default ProtectedComponent;
